
import { useFilter } from '../../../filter/hook'
import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'
import { getPrevFilter, getNextFilter } from '../../../filter/utils/prefetchFilters'

export default function useCurrentCore() {

  const{filter} = useFilter()
  const prevFilter = getPrevFilter(filter);
  const nextFilter = getNextFilter(filter);

  const currentQuery = useQuery({
    queryKey: ['current-consumption', filter],
    queryFn: () => dataAPI.getCurrentSingleCounter(filter)
})

  // Préchargement des données pour les fenêtres précédente et suivante
  useQuery({
    queryKey: ['current-consumption', prevFilter],
    queryFn: () => dataAPI.getCurrentSingleCounter(prevFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });

  useQuery({
    queryKey: ['current-consumption', nextFilter],
    queryFn: () => dataAPI.getCurrentSingleCounter(nextFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });
  return{
      
      filter,
      currentQuery : {
        data : currentQuery.data,
        isLoading : currentQuery.isLoading,
        isSuccess : currentQuery.isSuccess,
        isError : currentQuery.isError,
        error : currentQuery.error,
        refetch : currentQuery.refetch,
        isRefetching : currentQuery.isRefetching
      },
  }
}
